<template>
  <div class="style-bar py-1 flex-row d-flex space-between">
    <div class="d-flex flex-row flex-grow-1">
      <font-size v-if="isEnabled('fontSize')" ref="fontSize" class="ml-2" :styles.sync="localStyles" :default-size="defaultFontSize"></font-size>
      <font-color v-if="isEnabled('color')" ref="color" css-key="color" class="ml-2" :styles.sync="localStyles"></font-color>
      <font-color v-if="isEnabled('background')" ref="background" css-key="background" class="ml-2" :styles.sync="localStyles"></font-color>
      <font-alignement v-if="isEnabled('textAlign')" ref="textAlign" class="ml-2" :styles.sync="localStyles"></font-alignement>
    </div>
    <!-- For extra action buttons next to the clear formatting button -->
    <slot name="actions"></slot>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-icon class="mr-3" color="black" v-on="on" @click="clearFormatting()">mdi-format-clear</v-icon>
      </template>
      <span>{{$t('restore_default_style')}}</span>
    </v-tooltip>
  </div>
</template>

<script>

import FontSize from '@/components/utils/styles-widgets/FontSize'
import FontColor from '@/components/utils/styles-widgets/FontColor'
import FontAlignement from '@/components/utils/styles-widgets/FontAlignement'

export default {
  name: 'StyleBar',
  props: {
    styles: {},
    cssKeys: {
      type: Array
    },
    defaultFontSize: {
      type: Number,
      default: 12
    }
  },
  components: {
    FontSize,
    FontColor,
    FontAlignement
  },
  watch: {
    'localStyles' (newVal) {
      if (newVal && !newVal.clear) {
        this.$emit('update:styles', { ...this.styles, ...newVal })
      }
    }
  },
  data () {
    return {
      localStyles: {}
    }
  },
  created () {
    if (this.styles) {
      this.localStyles = JSON.parse(JSON.stringify(this.styles))
    }
  },
  methods: {
    clearFormatting () {
      this.localStyles = { clear: true }
      this.$emit('update:styles', { clear: true })
      this.cssKeys.forEach((key) => {
        if (this.$refs[key]) {
          console.log('reset ' + key)
          this.$refs[key].reset()
        }
      })
    },
    isEnabled (key) {
      return this.cssKeys.findIndex((k) => k === key) >= 0
    }
  }
}

</script>

<style lang="sass" scoped>

.style-bar
  background: white

</style>
